<template>
   <div class="page-wrap order-wrap">
      <div class="page-swipe">
               <div v-for="(item, index) in profileOrders" :key="'order_'+index" class="order-card" v-if="profileOrders.length > 0">
                  <van-cell class="card-title">
                     <template slot="title">
                        <div>
                           <span class="username">
                              <van-icon name="contact" />
                              <span class="van-cell-text">
                                 {{item.name}}
                                 <sby-member-icon v-if="item.vip" />
                              </span>
                           </span>
                              <span style="float:right;" v-if="item.processingOrders">
                                <span v-if="isServiceing(item.processingOrders)">
                                   <van-tag type="success">服务中</van-tag>
                                </span>
                              </span>
                        </div>
                     </template>
                  </van-cell>
                  <div class="order-row" v-if="item.processingOrders">
                     <section class="order-row-title">
                        <van-cell :border="false">
                           <template slot="title">
                              <van-tag type="success" color="#efefef" text-color="#5d5c5c" style="font-size: 14px;">缴纳状态</van-tag>
                           </template>
                        </van-cell>
                     </section>
                     <template v-for="processingOrder in item.processingOrders">
                        <van-cell :is-link="true" @click="goOrderProgress(processingOrder.orderno)" :border="false" v-for="(payment_item, index) in processingOrder.payment_items" v-bind:key="payment_item">
                           <span> {{processingOrder['item_' + payment_item].status_desc}} </span>
                           <template slot="title"> <span style="color:#8c8c8c;">{{processingOrder.payment_items_desc[index]}}</span> </template>
                        </van-cell>
                     </template>
                  </div>
                  <div class="order-row van-hairline--top">
                     <section class="order-row-title">
                        <van-cell class="" :border="false">
                           <template slot="title"><van-tag type="success" color="#efefef" text-color="#5d5c5c" style="font-size: 14px;">缴纳账单</van-tag></template>
                        </van-cell>
                        <van-cell
                          v-if="item.currentBills && item.currentBills.length > 0"
                          v-for="bill in item.currentBills"
                          v-bind:key="bill.id"
                           class=""
                           :border="false"
                           :is-link="true"
                           :to="`/order/detail/${bill.orderno}`"
                           >
                           <span class="bill-item-fee margin-right-10">
                           ￥<span><b>{{bill.total_real_fee }}</b></span>
                           </span>
                           <span class="cell-bill-status">
                           <span :class="statusColor(bill.pay_state)">{{status(bill.pay_state)}}</span>
                           </span>
                           <template slot="title"> <span style="color:#5d5c5c;">{{bill.months[0]}}</span>
                              <span
                                 type="success"
                                 color="rgb(140 154 147)"
                                 class="margin-left-5"
                                 plain
                                 v-for="pitem in bill.payment_items_desc"
                                 v-bind:key="pitem"
                                 >{{bill.payment_way === 'payback' ? '补缴' : ''}}{{pitem}}</span>
                           </template>
                        </van-cell>
                       <van-cell :border="false" :is-link="true" v-if="item.currentBills && item.currentBills.length == 0" :to="`/order/new?type=shebao,gongjijin&profileid=${item.id}`">
                        <template slot="title"> <span style="color:#8c8c8c;" > {{nowMonth}} <span class="margin-left-5">未下单</span></span></template>
                        <span style="color:#8c8c8c;">点击快捷下单</span>
                     </van-cell> 
                     </section>
                  </div>
                  <van-cell>
                     <div style="float:right;">
                      <sby-apply-attrition :key="comApplyAttr" v-if="item.processingOrders" :orders="item.processingOrders" class="margin-right-10" :refresh="refresh" />
                      <van-button :disabled="!item.processingOrders || item.processingOrders.find(it => it.pay_state !='paid')" @click="goPayback(item.id)" class="order-action margin-right-10" size="small" >补缴下单</van-button>
                      <van-button @click="showHistoryOrders(item)" class="order-action" size="small" >更多账单</van-button>
                     </div>
                  </van-cell>
               </div>
               <p
                  class="no-data"
                  v-if="profileOrders.length === 0 && profileHistoryOrders.length == 0"
                  >
                  <van-icon name="records" />
                  暂无代缴记录
               </p>
               <div v-for="(item, index) in profileHistoryOrders" :key="index" class="order-card" v-if="profileHistoryOrders.length > 0">
                  <van-cell class="card-title">
                     <template slot="title">
                        <div>
                           <span class="username">
                              <van-icon name="contact" />
                              <span class="van-cell-text"> {{item.name}} </span>
                           </span>
                        </div>
                     </template>
                     <span style="float:right;">
                        <span v-if="item.processingOrders
                          && item.processingOrders.filter(it => ['cancel'].includes(it.state)).length == item.processingOrders.length">
                            <van-tag type="warning">已结束</van-tag>
                        </span>
                        <span  style="color: #b1afaf;">|
                          <van-icon name="delete" @click="deleteProfile(item.id)"/>
                        </span>
                     </span>
                  </van-cell>
                  <div class="order-row van-hairline--top">
                     <section class="order-row-title" v-if="item.lastBill">
                        <van-cell :border="false"> <van-tag type="success" color="#efefef" text-color="#5d5c5c" >缴纳账单</van-tag></van-cell>
                        <van-cell :border="false" :is-link="true" :to="`/order/detail/${item.lastBill.orderno}`">
                           <span class="bill-item-fee margin-right-10">
                           ￥<span><b>{{item.lastBill.total_real_fee || 0 }}</b></span>
                           </span>
                           <span class="cell-bill-status">
                           <span :class="statusColor(item.lastBill.pay_state)">{{status(item.lastBill.pay_state)}}</span>
                           </span>
                           <template slot="title"> <span style="color:#5d5c5c;">{{item.lastBill.months[0]}}</span>
                              <span
                                 type="success"
                                 color="rgb(140 154 147)"
                                 class="margin-left-5"
                                 plain
                                 v-for="pitem in item.lastBill.payment_items_desc"
                                 v-bind:key="pitem"
                                 >{{item.lastBill.payment_way === 'payback' ? '补缴' : ''}}{{pitem}}</span>
                           </template>
                        </van-cell>
                     </section>
                     <van-cell :border="false" :is-link="true" :to="`/order/new?type=shebao,gongjijin&profileid=${item.id}`">
                        <template slot="title"> <span style="color:#8c8c8c;" > {{nowMonth}} <span class="margin-left-5">未代缴</span></span></template>
                        <span style="color:#8c8c8c;">点击快捷下单</span>
                     </van-cell>
                  </div>
                  <van-cell>
                     <div style="float:right;">
                      <van-button v-if="item.lastBill" @click="showHistoryOrders(item)" class="order-action" size="small" >更多账单</van-button>
                     </div>
                  </van-cell>
               </div>
         <van-dialog :title="showHistoryTitle" confirmButtonText="确认" v-model="showHistoryDialog" >
            <van-list  style="padding-top:20px;">
              <van-cell  :border="true" :to="`/order/detail/${order.orderno}`"
                :is-link="true" :title="getOrderDateText(order)" v-for="order in profileAllOrders" v-bind:key="order.orderno">
                <span v-if="order.payment_way === 'payback'"><van-tag type="warning" plain >补缴</van-tag></span>
                {{order.payment_items_desc.join(' ')}}
              </van-cell>
            </van-list>
         </van-dialog>
      </div>
      <div></div>
      <van-submit-bar
         :price="amountWaitFee * 100"
         button-text="去付款"
         label="本月合计："
         v-if="amountWaitFee > 0"
         style="margin-bottom: 50px;"
         @submit="goToPayOrder()"
         ></van-submit-bar>


        <van-dialog v-model="giftDialogShow" confirmButtonText="去邀请好友" @confirm="goGift()"  className="gift-dialog" show-cancel-button>
       <img src="/static/as/images/slogan.png" alt="" style=" width: 80%;">
       <img src="/static/as/images/reward.png?s=2" alt="" style=" width: 80%; ">
    </van-dialog>
   </div>
</template>
<script>
import {
  NavBar,
  Button,
  Row,
  Col,
  Field,
  CellGroup,
  Toast,
  Checkbox,
  CheckboxGroup,
  Cell,
  Icon,
  Tab,
  Tabs,
  List,
  Dialog
} from "vant";
import {
  PaymentWay,
  PaymentItem,
  PaymentTerm,
  PayStatus,
  PayType,
  OrderStatus,
  PaymentItemEx
} from "./util/state_desc";
import _ from "lodash";
import VueClipboard from "vue-clipboard2";
import Vue from "vue";
Vue.use(VueClipboard);
import moment from "moment";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Icon.name]: Icon,
    [List.name]: List,
    [Cell.name]: Cell
  },
  props: ["message"],
  name: "order-list",
  data: function() {
    return {
      active: 0,
      list: [],
      showPaySwitch: false,
      amountWaitFee: 0,
      serviceAuditFee: 0,
      amountBillFee: 0,
      amountFee: 0,
      serviceWaitFee: 0,
      currentBillIds: [],
      amountFeeDetail: {},
      amountAuditFee: 0,
      selectedBills: [],
      selectedMonth: null,
      daiJiaoCount: 0,
      showHistoryDialog: false,
      showHistoryTitle: '',
      profileOrders: [],
      profileHistoryOrders: [],
      profileAllOrders: [],

      giftDialogShow: false,
      showPaybackTips: false,
      comApplyAttr: 100010,
 
    };
  },

  mounted: function() {
    this.refresh();
    this.selectedMonth = this.currentMonth;

    setTimeout(() => {
      this.giftDialogShow =  this.$route.query.pay_success === 'true';
      this.showPaybackTips = this.$route.query.payback_tips === 'true';
      this.paySuccessProfileId = this.$route.query.profileid;

    }, 1500);

  },
  computed: {
    currentMonth() {
      if (this.selectedMonth) {
        return moment(this.selectedMonth).format("YYYY-MM");
      } else {
        return moment().format("YYYY-MM");
      }
    },
    nowMonth() {
      return moment().format("YYYY-MM");
    },

    currentMonthNum() {
      return moment(this.currentMonth).format("M");
    }
  },
  methods: {
    goback: function() {
      this.$router.go(-1);
    },
    isServiceing(processingOrders) {
      return processingOrders.find(it => ['pass', 'processing', 'renew', 'renewed'].includes(it.state)) 
    },
    showPaybackTipDialog() {
      if (this.showPaybackTips) {
        Dialog.confirm({
          title: '温馨提示',
          message: '如需补缴社保请务必在当天提交,遇节假日可顺延。',
          confirmButtonText: '社保近三月补缴'
        }).then(() => {
          this.goPaybackShebao();
         });
      }
    },

    goGift: function() {
      this.$router.push("/gift");
    },
    goPaybackShebao: function() {
      this.$router.push(`/order/new?type=shebao&profileid=${this.paySuccessProfileId}&payback=1`);
    },
    getOrderDateText(order) {

      let start = moment(order.payment_date_start).format("YYYY-MM");
      let end = moment(order.payment_date_end).format("YYYY-MM");
      if (start === end) {
        return start;
      }
      return start+'~'+end;
    },
    showHistoryOrders(item) {
      this.loadProfileHistoryOrders(item.id);
      this.showHistoryDialog = true;
      this.showHistoryTitle = item.name + "的全部账单";
    },

    goToPayOrder() {
      this.$router.push("/order/pay?month=" + this.currentMonth);
    },
    monthChange(newMonth, isCheck) {
      if (
        isCheck &&
        this.amountWaitFee > 0 &&
        this.selectedMonth === moment().format("YYYY-MM")
      ) {
        Toast("请先支付本月代缴费");
        return;
      }
      this.selectedMonth = newMonth;
      this.refresh();
    },
    goCreateOrder: function(type) {
      if (!type) {
        this.$router.push("/order/new");
      } else {
        this.$router.push("/order/new?type=" + type + "&tab=1  ");
      }
    },
    goOrderProgress(orderno) {
      this.$router.push(`/order/detail/${orderno}/progress`);
    },
 
    paySuccess() {
      this.showPaySwitch = false;
      this.refresh();
    },
    refresh: function() {
      this.$http
        .post("/api/order/my")
        .then(response => {
          if (response) {
            let profileOrders = [];
            let profileHistoryOrders = [];
            let resultData = response.data.data;
            for (let item of resultData) {
              if ((item.currentBills && item.currentBills.length > 0) || 
                (item.processingOrder && ['processing', 'renew', 'renewed'].includes(item.processingOrder.state))) {
                profileOrders.push(item);
              } else {
                profileHistoryOrders.push(item);
              }
            }
            this.profileOrders = profileOrders;
            this.profileHistoryOrders = profileHistoryOrders;
            this.comApplyAttr++;

          }
        });

      this.$http
        .get("/api/bill/waitFeeCurrent", {
          params: { month: this.currentMonth }
        })
        .then(res => {
          this.amountFeeDetail = res.data.data;
          this.amountAuditFee = res.data.data.amountAuditFee;
          this.currentBillIds = res.data.data.billIds;
          this.amountWaitFee = res.data.data.amountWaitFee;
          this.serviceWaitFee = res.data.data.serviceWaitFee;
          this.serviceAuditFee = res.data.data.serviceAuditFee;
          this.amountFee = res.data.data.amountFee;
          this.amountBillFee = res.data.data.amountBillFee;
          this.selectedBills = [
            ...res.data.data.pendingIds,
            ...res.data.data.paybackBillIds
          ];
        });
      //获取全部的
      this.appendAll(false, true);
     },
    loadAmountFeeDetail(billIds) {
      this.$http
        .get("/api/bill/waitFee", { params: { ids: billIds.join(",") } })
        .then(res => {
          this.amountFeeDetail = res.data.data;
        });
    },
    goPayback(profileid) {
      this.$router.push(`/order/new?type=shebao&profileid=${profileid}&payback=1`);
    },
    loadProfileHistoryOrders(pid) {
      this.profileAllOrders = []
      this.$http
        .get("/api/order/byProfile", { params: { pid: pid } })
        .then(res => {
          this.profileAllOrders = res.data.data;
        });

    },
    // 删除参保人
    deleteProfile (id) {
      Dialog.confirm({
        message: '确定删除该参保人吗？'
      }).then(() => {
        this.$http.get(`/api/profile/delete?id=${id}`)
          .then((response) => {
            this.refresh();
            Toast("删除成功");
          }).catch((err) => {
            console.error(err);
          });
      });
    },
    status: function(payState, state) {
      return PayStatus[payState];
    },
    statusColor: function(payState) {
      return "status-" + payState;
    },
    getOrderState: function(item) {
      return item.isPaid && (item.state === "toreview" || item.state === "pass")
        ? "服务中"
        : item.state_desc;
    },
    getType: function(item, way) {
      return PaymentItem[item] + PaymentWay[way];
    },
    format: function(date) {
      return moment(date).format("YYYY-MM");
    },
  
    appendAll: function(toast = true) {},
    makeOrder: function() {
      this.$store.commit("stashProfile", {}, false);
      this.$router.push({ name: "basic-profile-init" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../assets/less/var.less";

.page-swipe {
  padding-top: 10px;
}

.van-dialog__content {
  .van-list {
    .van-cell {
      padding-top: 10px;
    }
  }
}
.order-wrap {
  padding-bottom: 120px;


 

  .pay-button {
    background-color: #218adc;
    border-radius: 20px;
    font-size: 12px;
    margin-top: 55px;
    box-shadow: 2px 2px 5px #77c3ff;
    font-weight: 600;
    padding: 5px;
    text-align: center;
    left: 0;
    bottom: 0;
    height: 20px;
    z-index: 200;
    position: fixed;
    top: 80%;
    width: 100px;
    margin: 0 auto;
    left: 37%;
  }
  .icon-pay-finished {
    /*
        font-size: 35px;
    margin-top: 25px;
    */
    margin-right: 5px;
    font-size: 20px;
  }

  .van-cell {
    background-color: #fbfbfb;
  }
}

.van-cell {
  padding: 10px 10px;
  padding-top: 0;
  &:first-child {
    padding-top: 10px;
  }
  .van-icon {
    font-size: 14px;
  }
}
.load-more {
  margin-top: 20px;
  margin-bottom: 20px;
}

.btn-new {
  display: block;
  width: 50%;
  text-align: center;
  margin: 20px auto;
  color: white;
  background-color: @defaultColor;

  .icon {
    width: 20px;
    height: 20px;
  }
}
.period {
  background-color: #38f;
  color: white;
  width: 28px;
  height: 28px;
  font-size: 0.7rem;
  line-height: 30px;
  border-radius: 31px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  font-weight: 500;
}

.order-card {
  margin: 0px 10px 10px;
  box-shadow: 5px 5px 5px #f5eded;
  border-radius: 5px;

  .card-title {
    /*
       background-color: #F0FAFC;
       */
    .username {
      font-weight: 500;
      color: #5d5c5c;
      font-size: 16px !important;
    }
  }
  .content {
    font-size: 14px;
    & > span {
      display: block;
      padding-top: 5px;
    }
  }
  .cell-content {
    background-color: #fbfbfb;
    :after {
      border-bottom-width: 0 !important;
    }
  }
  .cell-bill {
    padding: 5px 10px;
    padding-right: 0;
    line-height: 16px;

    .bill-item-month {
      font-size: 14px;
      color: gray;
      display: inline-block;
      text-align: left;
      line-height: 27px;
    }
    .bill-item-fee {
      font-weight: 800;
      line-height: 27px;
      font-size: 14px;
    }
    .cell-bill-status-col {
      text-align: right;
      float: right;
      margin-right: 14px;
    }
    .cell-bill-status {
      text-align: right;
      font-size: 12px;
      display: inline-block;
      float: right;
      color: #d2a725;
      line-height: 27px;
    }
  }
  .name {
    margin-right: 20px;
    min-width: 60px;
    display: inline-block;
  }
  .label {
    color: @defaultDescColor;
  }
  .van-icon-delete {
    font-size: 10px;
  }

  .fail,
  .pending,
  .money {
    color: red;
  }
  .paid {
    color: #06bf04;
  }
}
.order-row {
  font-size: 14px;
  color: #5d5c5c;
  .van-cell {
     .van-cell__title {
      font-size: 14px;
    }
    .van-cell__value {
      font-size: 14px;
    }
  }
}



@media screen and (max-width: 320px) {
  .cell-bill-status {
    font-size: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order-list-new.vue